const { cELM, debounce, Wrap4Arrow, isMobile } = require("../../utils");
const Chat = require("../../chat");
const Scroller = require("../scroller");
const sanitizer = require('../../utils/sanitizer');
class AutoCompleteInput {
  constructor(data) {
    this.data = data;
    this.element = cELM("div", "option-block autocomplete");

    if (process.env.MOBILE_APP) {
      // Fixes dropdown when the software keyboard comes up (iPad mini)
      this.element.classList.add('mobile');
    }

    if (data.mode) {
      this.mode = data.mode;
      this.element.classList.add(data.mode);
      if (data.mode == "popup-autocomplete") {
         const textSpan = cELM("span", "")
         textSpan.addELM(cELM("span", "titletext", data.text));
         textSpan.addELM(cELM("span", "subtext", data.subtext));
         this.text =  textSpan;
      }
    }
    this.__elements = null;
    this.createElement();
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  createElement() {
    const _self = this;
  
    const inputContainer = cELM("div", "inputs-wrapper");
    const searchBlock = cELM("div", "search-block");
    const inputEl = cELM("input", "text-input search-input");
    this.inputElement = inputEl;
    inputEl.placeholder = getLngTxt("input.placeholder.type");

    if (_self.data && _self.data.placeholder) {
      inputEl.placeholder = _self.data.placeholder;
    }

    const buttonEl = cELM("div", "go-button go-button-active", getLngTxt("button.submit"));

    if (_self.data && _self.data.button) {
      buttonEl.innerHTML = _self.data.button;
    }
    

    const handleKeyUp = function(event) {
      
      const value = event.target.value;
      
      if (value.trim() == "") 
        return;

      if (!event.target.data)
        event.target.data = {};
      
      if (event.target.data['previousValue'] === value)
        return;      

      event.target.data['previousValue'] = value

      const sanitizedValue = sanitizer.sanitizeString(value);

      if (sanitizedValue.trim() == "") return;

      if (event.key === "Enter") {
        buttonEl.click();
        return;
      }

      _self.updateSuggestions(null, { showSpinner:true });

      if (_self.mode == "popup") {
        //_self.updateSuggestions(null,{showLoading:true});
      } else {
        if (window.__FN_DATA_WRAPPER) {
          let data = window.__FN_DATA_WRAPPER(sanitizedValue);
          
          data = (typeof data == 'string') 
            ? { text: data, id: _self.data.id }
            : { ...data, id: _self.data.id };

          Chat.default.send(data, null, _self.element );
        } else {
          Chat.default.send({
              id: _self.data.id,
              typing: sanitizedValue.toUpperCase(),
              reference: {
                id: _self.data.id,
              }, // "medication" // AR: why as thise hardcoded?
            },
            null,
            _self.element,
          );
        }
      }
    };

    inputEl.onkeyup = debounce(handleKeyUp, 200);

    buttonEl.onclick = function(evt) {
      if (inputEl.value.trim() == "") return;
      inputEl.blur();

      const sanitizedValue = sanitizer.sanitizeString((inputEl || {}).value || '');

      if (sanitizedValue.trim() == "") return;

      if (_self.mode == "popup") {
        _self.updateSuggestions(null, { showLoading: true });

        Chat.default.send(
          {
            id: _self.data.id,
            typing: sanitizedValue.toUpperCase(),
            reference: {
              id: _self.data.id,
            }, //"medication" //AR: why as thise hardcoded?
          },
          null,
          _self.element,
        );

      } else {
        Chat.default.send({
            text: sanitizedValue,
            id: _self.data.id,
          }, 
          null, 
          _self.element
        );
      }
      
     

    };

    inputContainer.addELM(Wrap4Arrow(inputEl, true));
    inputContainer.addELM(buttonEl);

    if (_self.mode == "popup-autocomplete")
    {

      this.element.addELM(inputContainer);
      this.element.addELM(searchBlock);
      
    }
    else
    {
      this.element.addELM(searchBlock);
      this.element.addELM(inputContainer);
    }

    if (this.text) {
      this.element.addELM(this.text);

  
      // inputEl.onclick = () => {
      //   if (this.text) {
      //       this.element.removeChild(this.text)
      //       this.text = null
      //   }
      // }
    }

    this.__elements = {
      inputEl,
      searchBlock,
      buttonEl,
      inputContainer
    };

    if(_self.mode == "popup-autocomplete" && this.data.values && this.data.values.trim && this.data.values.toLowerCase() === 'cancel') {
      //add cancel button
      const cancelBtn = cELM("div", "button-cancel autocomplete-cancel-btn", this.data.values);
      cancelBtn.onclick = function(evt) {
        searchBlock.classList.remove("search-block-active");
        buttonEl.classList.add("go-button-active");
        inputContainer.classList.add('search-hidden');
        _self.text.style.display = 'none';
        if(cancelBtn) {
          cancelBtn.classList.add('search-hidden')
        }
        Chat.default.send({
          id: _self.data.id,
          action: 'cancelSearch' 
        });
      };
      const rowBtn = cELM('div', 'row row-buttons row-autocomplete');
      rowBtn.addELM(cancelBtn);
      this.element.addELM(rowBtn);
      this.__elements.cancelBtn = cancelBtn;
    }

    if(_self.mode == "popup-autocomplete") {
      //to avoid that the mobile keyboard push up cancel button
      // _self.__elements.inputEl.onfocus = function() {
      //   if(isMobile() && _self.__elements.cancelBtn) {
      //     _self.__elements.cancelBtn.style.position = "absolute";
      //   }
      // }
      // _self.__elements.inputEl.onblur = function() {
      //   if(isMobile() && _self.__elements.cancelBtn) {
      //     //_self.__elements.cancelBtn.style.position = "relative";
      //   }
      // }
    }
    return this.element;
  }


  addSpinner(values, params) {
    const { searchBlock } = this.__elements;
    const _self = this;

    if(params && params.showSpinner && (!values || values.length === 0)) {
      const html = `<div class="autocomplete-thinking">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>`;

      _self._spinner = true;

      const _el = cELM("div", "search-loading", html);
      searchBlock.addELM(_el);

      if(_self.text && _self.text.style) {
        _self.text.style.display = 'none';
      }
    }
  }

  addKeepTyping() {
    const { searchBlock } = this.__elements;
    const _self = this;

    let keepTypText = 'Keep typing to Search';
    
    if (_self.data && _self.data.keepTypingText) {
      keepTypText = _self.data.keepTypingText;
    }

    const _el = cELM("div", "search-keep-typing", keepTypText);
    searchBlock.addELM(_el);
  }

  updateSuggestions(values, params) {
    const { searchBlock, inputEl, buttonEl, inputContainer, cancelBtn } = this.__elements;
    const _self = this;

    const sanitizedValue = sanitizer.sanitizeString((inputEl || {}).value || '');

    inputContainer.classList.remove('search-hidden');

    let child = searchBlock.lastElementChild;
    while (child) {
      searchBlock.removeChild(child);
      child = searchBlock.lastElementChild;
    }

    if (!values || values.length <= 2) {
      searchBlock.classList.add("less-sugg");
    } else {
      searchBlock.classList.remove("less-sugg");
    }

    if (params && !params.showSpinner && params.showLoading && !values) {
      const _el = cELM("div", "search-loading", "Searching");
      searchBlock.addELM(_el);
    }

    if ((!values || values.length === 0) && inputEl.value && _self.mode != "popup") {
      const _el = cELM("div", "search-item", sanitizedValue);
      _el.onclick = function() {
        searchBlock.classList.remove("search-block-active");
        buttonEl.classList.add("go-button-active");
        inputContainer.classList.add('search-hidden');
        if(cancelBtn) {
          cancelBtn.classList.add('search-hidden')
        }
        Chat.default.send({
            text: sanitizedValue,
            id: _self.data.id
          }, 
          null, 
          _self.element
        );

      };
      searchBlock.addELM(_el);
      this.addSpinner(values, params);
    } else if (_self.mode == "popup" && values && values.length === 0) {
      const _el = cELM("div", "search-nothingfound", "Nothing found try again");
      searchBlock.addELM(_el);
    } else if (values) {
      if (_self.data && _self.data.instruction) {
        const _el = cELM("div", "search-instruction", _self.data.instruction);
        searchBlock.addELM(_el);
      }

      values.map(si => {
        const _el = cELM("div", "search-item", si.name);
        _el.onclick = function() {
          inputEl.value = si.name || si.value;
          inputEl.blur();
          searchBlock.classList.remove("search-block-active");
          buttonEl.classList.add("go-button-active");
          inputContainer.classList.add('search-hidden');
          if(cancelBtn) {
            cancelBtn.classList.add('search-hidden')
          }

          let valueToSend = si.value || si.name;
          if (params && params.sendObject) {
            valueToSend = si;
          }

          Chat.default.send({
              text: valueToSend,
              id: _self.data.id,
            }, 
            null, 
            _self.element
          );
 
        };
        searchBlock.addELM(_el);
      });
    }

    if(_self.mode != "popup-autocomplete") {
      if (!searchBlock.classList.contains("search-block-active")) {
        Scroller.smoothScrollTo(window.scrollY + 175);
      }
    }

    if(!params || (params && params.sendObject)) {
      const noValues = !values || !values.length;
      const sameOption = (values || []).length === 1 && inputEl.value.trim().toLowerCase() === ((values[0] || {}).name || '').trim().toLowerCase()

      if(noValues || sameOption){
        this.addKeepTyping();
      }
    }

    if(this.text && _self.mode == "popup-autocomplete"){

      if(!values){
        // this.text.style.display = 'block';  
      }
      else
      {
        this.text.style.display = 'none';   
      }
     
    }

    searchBlock.classList.add("search-block-active");
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.inputEl.value = "";

    if(this.text && this.mode == "popup-autocomplete"){
       this.text.style.display = 'block';
    }
    
    const { searchBlock, inputEl, buttonEl, inputContainer } = this.__elements;
    const _self = this;
    inputContainer.classList.remove('search-hidden');
    let child = searchBlock.lastElementChild;
    while (child) {
      searchBlock.removeChild(child);
      child = searchBlock.lastElementChild;
    }    

  }

  focus() {
    if (this.inputElement) {
      this.inputElement.focus();
    }
  }
}

module.exports = AutoCompleteInput;
